<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.dashboard') }}
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>
      <section
        v-if="ready"
        style="margin-top: 10px;">
        <base-not-found-data
          v-if="filterSessions.length === 0"
          :title="$t('message.notfoundbranch')"
          :detail="$t('message.createnewbranchat')"
        />
        <div
          v-for="(item, index) in filterSessions"
          v-else
          :key="index"
          class="col-sm-12 col-md-12 col-xl-5"
          style="margin-bottom: 30px;"
        >
          <div
            v-if="!item.isInit"
            class="col-12 no-padding card"
          >
            <div
              class="card-body"
              style="padding: 15px 15px 13px 15px;">
              <div
                class="row no-padding mb-1"
                style="margin-left: 0;margin-right: 0;">
                <div class="col no-padding">
                  <section-title
                    :title="item.branchName"
                    fontweight="bold"/>
                </div>
              </div>
              <p class="card-text row">
                <span class="col-4">{{ $t('apps.pos.message.salestartedtime') }}</span>
                <span class="col-8 text-right">-</span>
              </p>
              <p class="card-text row">
                <span class="col-4">{{ $t('apps.pos.message.saledurationtime') }}</span>
                <span class="col-8 text-right">-</span>
              </p>
              <p class="card-text row">
                <span class="col-4">{{ $t('apps.pos.message.transactions') }}</span>
                <span class="col-8 text-right">-</span>
              </p>
              <div style="min-height: 36px;">
                <template v-if="!loading_.btn_new">
                  <button
                    class="btn btn-web col-12"
                    @click="newSession(item.branchId)">
                    <i class="fas fa-sign-in-alt"/>
                    {{ $t('apps.pos.button.newsession') }}
                  </button>
                </template>
                <template v-if="loading_.btn_new">
                  <button
                    class="btn btn-web col-12"
                    disabled>
                    <i class="fas fa-spinner spin"/>
                  </button>
                </template>
              </div>
            </div>
          </div>

          <div
            v-else
            class="col-12 no-padding"
          >
            <div class="col-12 no-padding card">
              <div
                class="card-body"
                style="padding: 15px 15px 13px 15px;">
                <div
                  class="row no-padding mb-1"
                  style="margin-left: 0;margin-right: 0;">
                  <div class="col no-padding">
                    <section-title
                      :title="item.branchName"
                      fontweight="bold"/>
                  </div>
                  <div class="col no-padding">
                    <router-link-custom
                      :to="{name: 'PosTransactionDetail', query: {
                        ps_id: item.ps_id,
                        ps_code: item.ps_code
                      }}"
                      :text="item.ps_code"
                      :status="{
                        text: getStatusText(item.status),
                        color: getStatusColor(item.status),
                        type: 'icon'
                      }"
                      :to_appid="1"
                      :current_appid="1"
                      style="float: right;"/>
                  </div>
                </div>
                <p class="card-text row">
                  <span class="col-4">{{ $t('apps.pos.message.salestartedtime') }}</span>
                  <span class="col-8 text-right">{{ getDateTime(item.started_at) }}</span>
                </p>
                <p class="card-text row">
                  <span class="col-4">{{ $t('apps.pos.message.saledurationtime') }}</span>
                  <span class="col-8 text-right">{{ getDurationFriendlyBySeconds((moment(now).format('x') - moment(item.started_at).format('x')) / 1000, $t) }}</span>
                </p>
                <p class="card-text row">
                  <span class="col-4">{{ $t('apps.pos.message.transactions') }}</span>
                  <span class="col-8 text-right">{{ item.transactionInfo ? item.transactionInfo.count : 0 }}</span>
                </p>
                <p
                  v-if="stockBills.length > 0 && stockBills.some((bill) => bill.ps_id === item.ps_id)"
                  class="card-text text-center row"
                  style="padding: 15px 0px 12px 0;margin: 0;background: rgba(203,203,203,.2)"
                >
                  <span class="col-12 text-danger">{{ $t('apps.pos.message.warningtosyncdata', {number: stockBills.length}) }}</span>
                  <span
                    class="col-12"
                    style="font-size: 11px;">{{ $t('apps.pos.message.clicksyncbuttonbelow') }}</span>
                  <span class="col-12 mt-3">
                    <template>
                      <button
                        v-if="!$store.state.app.loading"
                        class="btn btn-sm btn-primary"
                        @click="insertBillsInStock(stockBills, item.ps_id)">
                        <i class="fas fa-sync-alt"/>
                        {{ $t('apps.pos.button.sync') }}
                      </button>
                      <button
                        v-else
                        :disabled="true"
                        class="btn btn-sm btn-primary">
                        <i class="fas fa-sync-alt spin"/>
                        {{ $t('apps.pos.button.sync') }}
                      </button>
                    </template>
                  </span>
                  <span class="col-12 mt-3">
                    <a
                      href="https://www.treesoft.io/th/manual/pos#dashboard"
                      target="_blank">
                      {{ $t('button.learnmore') }}
                      <i class="fas fa-external-link-alt"/>
                    </a>
                  </span>
                </p>
                <div
                  v-else
                  class="form-row"
                >
                  <div class="col-6">
                    <template v-if="!loading_.btn_resume">
                      <button
                        :disabled="disabled_.btn_resume"
                        class="btn btn-light col-12"
                        @click="resumeSession(item.ps_id)">
                        <i class="fas fa-sign-in-alt"/>
                        {{ $t('apps.pos.button.resumesession') }}
                      </button>
                    </template>
                    <template v-if="loading_.btn_resume">
                      <button
                        class="btn btn-light col-12"
                        disabled>
                        <i class="fas fa-spinner spin"/>
                      </button>
                    </template>
                  </div>
                  <div class="col-6">
                    <template v-if="!loading_.btn_close">
                      <button
                        :disabled="disabled_.btn_close"
                        class="btn btn-web col-12"
                        @click="closeSession(item.branch_id, item.ps_id, item.ps_code)">
                        <i class="fas fa-check"/>
                        {{ $t('apps.pos.button.closesession') }}
                      </button>
                    </template>
                    <template v-if="loading_.btn_close">
                      <button
                        class="btn btn-web col-12"
                        disabled>
                        <i class="fas fa-spinner spin"/>
                      </button>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import sidebarModule from './../../sidebarModule'
import _ from 'lodash'

export default {
  name: 'PosDashboard',
  data () {
    return {
      ready: false,
      loading_: {
        btn_new: false,
        btn_resume: false,
        btn_close: false,
      },
      disabled_: {
        btn_new: false,
        btn_resume: false,
        btn_close: false,
      },
      timer: null,
      now: new Date(),
      stockBills: [],
    }
  },
  computed: {
    ...mapGetters({
      loading: 'getLoading',
      error: 'getError',
      me: 'getMe',
      shop: 'getShopInfo',
      shopInfo: 'getShopInfo',
      getPosLocalStorage: 'getPosLocalStorage',
    }),
    posBranches () {
      return this.$store.state.posBranch.branches
    },
    mySessions () {
      return this.$store.state.possession.my.sessions
    },
    filterSessions () {
      return this.posBranches.map((branch) => {
        const mySession = this.mySessions.find((_mySession) => _mySession.branch_id === branch.branchId)
        if (mySession) {
          return {
            isInit: true,
            branchName: branch.name,
            ...mySession,
          }
        } else {
          return {
            isInit: false,
            branchName: branch.name,
            ...branch,
          }
        }
      })
    },
  },
  methods: {
    ...mapActions([
      'initPos',
      'deletePosStockBill',
      'insertPosBill',
      'setPosLocalStorage',
    ]),
    async newSession (branchId) {
      // set loading, disabled
      this.loading_.btn_new = true

      // insert
      let res = await this.$store.dispatch('insertPosSession', {
        branch_id: branchId,
      })
      let newPos = res.data

      // go to
      if (res.success) {
        this.$router.push({ name: 'PosDashboardSession',
          query: {
            id: newPos._id,
          } })
      }
    },
    async resumeSession (psId) {
      // set loading, disabled
      this.loading_.btn_resume = true
      this.disabled_.btn_close = true

      // update
      let res = await this.$store.dispatch('updatePosMySessionStatus', {
        ps_id: psId,
        status: 'selling',
      })

      // go to
      this.$router.push({ name: 'PosDashboardSession',
        query: {
          id: psId,
        } })
    },
    async closeSession (branchId, psId, psCode) {
      // set loading, disabled
      this.loading_.btn_close = true
      this.disabled_.btn_resume = true

      // update
      let res = await this.$store.dispatch('updatePosMySessionStatus', {
        branch_id: branchId,
        ps_id: psId,
        status: 'closed',
      })

      // go to
      this.$router.push({ name: 'PosTransactionDetail',
        query: {
          ps_id: psId,
          ps_code: psCode,
        } })

      // clear all order in pos
      this.$store.dispatch('clearPosOrderAll')
    },
    getStatusText (status) {
      if (status == 'selling') {
        return this.$t('status.pos.selling')
      } else if (status == 'paused') {
        return this.$t('status.pos.paused')
      }
    },
    getStatusColor (status) {
      if (status == 'selling') {
        return 'info'
      } else if (status == 'paused') {
        return 'warning'
      }
    },
    async insertBillsInStock (bills, psId) {
      var err = null

      for (let item of bills) {
        const bill = {
          ...item,
          analytics: {
            ...item.analytics,
            is_sync_manual: true,
          },
        }

        let res = await this.insertPosBill(bill)

        if (res.success) {
          this.deletePosStockBill(bill.uuid)
        } else {
          err = true
        }
      }

      if (!err) {
        // get my session
        await this.$store.dispatch('getPosMySession')

        // set my component data
        this.stockBills = []
        // update data in browser storeage
        this.setPosLocalStorage({ psId })

        // loading finish
        this.showFinish(this.$Progress)
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.saved'),
          color: 'success',
          icon: 'cloud',
        })
      }
    },
  },
  watch: {
    loading: function (isLoading) {
      this.showLoading(this.$Progress, isLoading)
    },
    error: function (msg) {
      this.showError(this.$Progress, this.$vs, msg, {
        title: this.$t('message.message'),
        text: this.$t('message.somethingwentwrong'),
      })
    },
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
  },
  async created () {
    await this.$store.dispatch('getPosBranches')
    await this.$store.dispatch('getPosMySession')
    // set stockbills
    for (const posSession of this.mySessions) {
      const posLocalStorage = this.getPosLocalStorage(this.shopInfo.shop_id, posSession.ps_id)
      if (posLocalStorage) {
        // init pos data
        this.initPos({
          stockbills: _.cloneDeep(posLocalStorage.stockBills) || [],
          orders: _.cloneDeep(posLocalStorage.orders) || [],
          tables: _.cloneDeep(posLocalStorage.tables) || [],
          display: _.cloneDeep(posLocalStorage.display),
        })
        // set my component data
        this.stockBills = _.cloneDeep(posLocalStorage.stockBills)
      }
    }
    this.timer = setInterval(() => this.now = new Date(), 1000)
    this.ready = true
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.pos.title'),
      current: {
        app_name: 'pos',
        app_id: 1,
        module_id: 1,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 0,
    })
  },
  destroyed () {
    this.leavePage(this.$Progress, [])
    clearInterval(this.timer)
  },
}
</script>

<style scoped>
.card-body .card-text {
  margin-bottom: 5px;
}
.card-body .card-text:last-of-type {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/All.vue